import _defineProperty from "/build/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import React, { useRef, useState, useEffect, useContext, useCallback } from "react";
import Link from "next/link";
import { useRouter } from "next/router";
import classnames from "classnames";
import styles from "@/styles/Breadcrumbs.module.scss";
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
var IconArrow = function IconArrow(props) {
  return /*#__PURE__*/_jsx("svg", _objectSpread(_objectSpread({}, props), {}, {
    children: /*#__PURE__*/_jsx("g", {
      transform: "translate(0.813 0.813)",
      children: /*#__PURE__*/_jsx("path", {
        d: "M.6.6l6,6.5,6-6.5",
        fill: "none",
        stroke: "#e6e6e6",
        strokeLinecap: "round",
        strokeWidth: "2"
      })
    })
  }));
};
IconArrow.defaultProps = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "14.826",
  height: "9.387",
  viewBox: "0 0 14.826 9.387"
};
export const BreadcrumbsContext = /*#__PURE__*/React.createContext({
  breadcrumbs: [],
  setBreadcrumbs: () => null
});
BreadcrumbsContext.displayName = "BreadcrumbsContext";
export function BreadcrumbsProvider(_ref) {
  let {
    children
  } = _ref;
  const {
    0: breadcrumbs,
    1: setBreadcrumbs
  } = useState([]);
  const router = useRouter();
  const timeoutId = useRef();
  const setBreadcrumbsLazy = useCallback(value => {
    timeoutId.current = setTimeout(() => {
      setBreadcrumbs(value);
    }, 10);
  }, []);
  useEffect(() => {
    const handleHistoryChange = () => {
      setBreadcrumbs([]);
    };
    router.events.on("routeChangeComplete", handleHistoryChange);
    return () => {
      if (timeoutId.current) {
        clearTimeout(timeoutId.current);
      }
      router.events.off("routeChangeComplete", handleHistoryChange);
    };
  }, []);
  const contextValue = {
    breadcrumbs,
    setBreadcrumbs: setBreadcrumbsLazy
  };
  return /*#__PURE__*/_jsx(BreadcrumbsContext.Provider, {
    value: contextValue,
    children: children
  });
}
function Breadcrumbs(_ref2) {
  let {
    hidden,
    mobile
  } = _ref2;
  if (hidden) return null;
  const router = useRouter();
  const {
    breadcrumbs
  } = useContext(BreadcrumbsContext);
  const fromWatchToTitle = href => {
    return href.includes("/title") && router.asPath.includes("/watch");
  };
  return /*#__PURE__*/_jsx("div", {
    className: classnames(styles.breadcrumbs, {
      [styles.mobile]: mobile
    }),
    children: /*#__PURE__*/_jsx("div", {
      className: styles.inner,
      children: breadcrumbs.map((breadcrumb, i) => /*#__PURE__*/_jsxs(React.Fragment, {
        children: [breadcrumb.href && fromWatchToTitle(breadcrumb.href) && /*#__PURE__*/_jsx("a", {
          href: breadcrumb.href,
          className: styles.link,
          children: /*#__PURE__*/_jsx("span", {
            title: breadcrumb.text,
            children: breadcrumb.text
          })
        }), breadcrumb.href && !fromWatchToTitle(breadcrumb.href) && /*#__PURE__*/_jsx(Link, {
          href: breadcrumb.href,
          className: styles.link,
          children: /*#__PURE__*/_jsx("span", {
            title: breadcrumb.text,
            children: breadcrumb.text
          })
        }), !breadcrumb.href && /*#__PURE__*/_jsx("span", {
          className: styles.link,
          title: breadcrumb.text,
          children: breadcrumb.text
        }), breadcrumbs.length != i + 1 && /*#__PURE__*/_jsx("span", {
          className: styles.arrow,
          children: /*#__PURE__*/_jsx(IconArrow, {})
        })]
      }, `breadcrumbs-${i}`))
    })
  });
}
export default /*#__PURE__*/React.memo(Breadcrumbs);
export const BreadcrumbsForFooter = () => {
  const {
    breadcrumbs
  } = useContext(BreadcrumbsContext);
  const hidden = breadcrumbs.length == 0;
  return /*#__PURE__*/_jsx("div", {
    className: classnames(styles.footerBreadcrumbs, {
      [styles.hidden]: hidden
    }),
    children: /*#__PURE__*/_jsx(Breadcrumbs, {
      mobile: true,
      hidden: hidden
    })
  });
};